import React from 'react';

/** Only PulseProducer owner tooling — same email as server-side privileged flows. */
export const PRODUCER_UNLOCK_EMAIL = 'pulsestockia@gmail.com';

/**
 * Full-screen "PRÓXIMAMENTE" for PulseProducer (module under construction).
 * Shown only inside ProducerPage after StudioOnboarding, never app-wide.
 */
export function ProducerComingSoonScreen({ onBack }) {
  return (
    <div className="min-h-screen bg-pulse-bg flex items-center justify-center px-4" data-testid="producer-coming-soon">
      <div className="w-full max-w-md text-center">
        <div className="w-20 h-20 rounded-2xl bg-pulse-primary mx-auto flex items-center justify-center mb-8">
          <span className="font-heading font-extrabold text-3xl text-black">P</span>
        </div>
        <h1 className="font-heading font-bold text-3xl text-white mb-3 tracking-tight">
          PRÓXIMAMENTE
        </h1>
        <p className="text-pulse-muted text-sm leading-relaxed mb-8">
          Estamos construyendo algo increíble.<br />
          PulseProducer estará disponible muy pronto.
        </p>
        <div className="w-16 h-1 bg-pulse-primary rounded-full mx-auto mb-8 animate-pulse" />
        <p className="text-pulse-muted text-xs mb-8">
          Gracias por tu paciencia.
        </p>
        {typeof onBack === 'function' && (
          <button
            type="button"
            onClick={onBack}
            className="text-sm text-pulse-primary hover:underline"
            data-testid="producer-coming-soon-back"
          >
            Volver a PulseMusic
          </button>
        )}
      </div>
    </div>
  );
}
